import { render, staticRenderFns } from "./ReveneusTypes.vue?vue&type=template&id=70a60d14&"
import script from "./ReveneusTypes.vue?vue&type=script&lang=js&"
export * from "./ReveneusTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports